import downloadIcon from '@disy/cadenza-icons/export.svg';

import { createIconButton } from 'ui/button/button';
import { setupMenuButton } from 'ui/menu/menu';

import { icon } from 'cadenza/utils/icon/icon';
import { EXPORT_BUTTON_STYLE_CLASS } from 'cadenza/header/subnav-constants';
import { ExportToXlsxAction } from 'cadenza/actions/table/export-to-xlsx-action';
import { ExportToCsvAction } from 'cadenza/actions/table/export-to-csv-action';

import i18n from './create-table-export-menu-actions.properties';

const exportActions = {
  XLSX: ExportToXlsxAction,
  CSV: ExportToCsvAction
};

export function createTableExportMenuButton (downloadOptions, actionOptions) {
  const button = createIconButton(icon(downloadIcon), i18n('menu.label'), {
    styleClass: EXPORT_BUTTON_STYLE_CLASS,
    variant: 'borderless'
  });
  setupMenuButton(button, () => createTableExportMenuActions(downloadOptions, actionOptions));
  return button;
}

function createTableExportMenuActions (downloadOptions, actionOptions) {
  return Object.entries(exportActions).flatMap(([ format, Action ]) => {
    if (!downloadOptions.includes(format)) {
      return [];
    }
    return [ new Action(actionOptions) ];
  });
}
